import { render } from "./IconLoader.vue?vue&type=template&id=22ad12fc"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconLoader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "22ad12fc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('22ad12fc', __exports__)) {
    api.reload('22ad12fc', __exports__)
  }
  
  module.hot.accept("./IconLoader.vue?vue&type=template&id=22ad12fc", () => {
    api.rerender('22ad12fc', render)
  })

}


export default __exports__